<template>
    <section>
        <div class="row">
            <div class="col-12 form-group">
                <h4 class="mb-0">Select a Search Criteria</h4>
                <div class="demo-inline-spacing">
                    <div class="custom-control custom-radio mt-0">
                        <input
                            type="radio"
                            id="from"
                            name="selected_column"
                            v-model="selectedColumn" 
                            class="custom-control-input"
                            value="from"
                        />
                        <label class="custom-control-label" for="from">From</label>
                    </div>
                    <div class="custom-control custom-radio mt-0">
                        <input
                            type="radio"
                            id="to"
                            name="selected_column"
                            v-model="selectedColumn" 
                            class="custom-control-input"
                            value="to"
                        />
                        <label class="custom-control-label" for="to">To</label>
                    </div>
                    <div class="custom-control custom-radio mt-0">
                        <input
                            type="radio"
                            id="message_pages"
                            name="selected_column"
                            v-model="selectedColumn" 
                            class="custom-control-input"
                            value="message_pages"
                        />
                        <label class="custom-control-label" for="message_pages">Pages</label>
                    </div>
                    <div class="custom-control custom-radio mt-0">
                        <input
                            type="radio"
                            id="status"
                            name="selected_column"
                            v-model="selectedColumn" 
                            class="custom-control-input"
                            value="status"
                        />
                        <label class="custom-control-label" for="status">Delivered Status</label>
                    </div>
                    <div class="custom-control custom-radio mt-0">
                        <input
                            type="radio"
                            id="status_text"
                            name="selected_column"
                            v-model="selectedColumn" 
                            class="custom-control-input"
                            value="status_text"
                        />
                        <label class="custom-control-label" for="status_text">Status</label>
                    </div>
                    <div class="custom-control mt-0">
                        <input
                            v-model="searchTerm"
                            placeholder="Search"
                            type="text"
                            class="d-inline-block form-control"
                        />
                    </div>
                </div>
            </div>
        </div>
        <vue-good-table
            mode="remote"
            v-on:page-change="onPageChange"
            v-on:per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :isLoading.sync="isLoading"
            :pagination-options="{
                enabled: true,
                perPageDropdown: [15, 20, 30, 40, 50, 100],
                dropdownAllowAll: false,
            }"
            :rows="rows"
            :columns="columns"
            :sort-options="{
                enabled: false
            }"
        >
            <template #table-row="props">
                <img class="img-thumbnail" v-if="props.column.field == 'thumbnail'" :src="settingStore.thumbnail" />
                <span v-if="props.column.field === 'action'">         
                    <div class="d-flex align-items-center col-actions">
                        <a
                            :href="props.row._file_url"
                            target="_blank"
                            class="mr-1 text-primary"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="View File"
                        >
                            <vue-feather type="eye"></vue-feather>
                        </a>
                    </div>
                </span>
                <div
                    v-if="props.column.field === 'status'"
                    class="badge badge-glow"
                    :class="props.row.status == 'Failed' ? 'badge-danger' : 'badge-primary'"
                >
                    {{ props.row.status }}
                </div>
            </template>
        </vue-good-table>
    </section>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import 'vue-good-table-next/dist/vue-good-table-next.css'
    import { VueGoodTable } from 'vue-good-table-next';
    import { useLocalizationStore } from '../../stores/LocalizationStore.js';
    import { useSettingStore } from '../../stores/SettingStore.js'
    import { fix } from 'mathjs'
    import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js'
    import moment from 'moment';
    export default {
        components: {
            VueGoodTable,
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                settingStore: useSettingStore(),
                faxHistory: reactive([]),
                searchTerm: ref(null),
                selectedColumn: ref('from'),
                limit: ref('15'),
                moment: moment,
            }
        },
        mounted() {
            if (!this.settingStore.isClicksendUpdated) {
                useSettingStore().fetchSetting();
            }else{
                this.getFaxHistory(this.settingStore.getUrl('/fax/history'));
            }
        },
        data() {
            return {
                isLoading: true,
                columns: [
                    {
                        label: 'Thumbnail',
                        field: 'thumbnail',
                        width: '120px',
                    },
                    {
                        label: 'Date Created',
                        field: 'date_added',
                        formatFn: this.formatDate
                    },
                    {
                        label: 'From',
                        field: 'from',
                        formatFn: this.formatPhone
                    },
                    {
                        label: 'To',
                        field: 'to',
                        formatFn: this.formatPhone
                    },
                    {
                        label: 'Pages',
                        field: 'message_pages',
                        formatFn: this.formatPages,
                    },
                    {
                        label: 'Price',
                        field: 'message_price',
                        formatFn: this.formatPrice,
                    },
                    {
                        label: 'Delivery',
                        field: 'status',
                        width: '180px',
                    },
                    {
                        label: 'Status',
                        field: 'status_text',
                        type: 'string',
                    },
                    {
                        label: 'View',
                        field: 'action'
                    }
                ],
                rows: [],
                totalRecords: 0,
                localizationStore: useLocalizationStore(),
            };
        },
        watch: {
            'settingStore.isClicksendUpdated'(value) {
                if (value) {
                    this.getFaxHistory(this.settingStore.getUrl('/fax/history'));
                }
                else {
                    setTimeout(() => {
                        toastr.error(
                            this.localizationStore.translate("clicksend.setting.error.message"),
                            'Error!'
                        );
                    }, "2000")
                }
            },
            'searchTerm'(value) {
                this.getFaxHistory(this.settingStore.getUrl('/fax/history'));
            },
            'selectedColumn'(value) {
                this.getFaxHistory(this.settingStore.getUrl('/fax/history'));
            },
        },
        methods: {
            getFaxHistory(url) {
                let $this = this;
                if (url.includes("?")) {
                    url = `${url}&limit=${$this.limit}`;
                }
                else {
                    const queryParams = new URLSearchParams({
                        'limit': $this.limit
                    });
                    url = `${url}?${queryParams.toString()}`;
                }
                if ($this.searchTerm != null && $this.searchTerm != '') {
                    if ($this.selectedColumn == 'to' || $this.selectedColumn == 'from') {
                        let phoneNumber = $this.searchTerm;
                        if (isValidPhoneNumber(phoneNumber, 'XX')) {
                            phoneNumber = parsePhoneNumber($this.searchTerm).format("E.164");
                        }
                        url = `${url}&q=${$this.selectedColumn}:%${phoneNumber}%`;
                    }
                    else {
                        url = `${url}&q=${$this.selectedColumn}:${$this.searchTerm}`;
                    }
                    
                }
                axios.get(
                    url,
                    {
                        auth: {
                            username: $this.settingStore.clicksend.clicksend_username,
                            password: $this.settingStore.clicksend.clicksend_password
                        }
                    }
                ).then(function(response) {
                    $this.faxHistory = response.data.data;
                    $this.rows = $this.faxHistory.data;
                    $this.totalRecords = $this.faxHistory.total;
                    $this.isLoading = false;
                }).catch(function(error) {
                    $this.rows = [];
                    $this.totalRecords = 0;
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            },    
            onPageChange(params) {
                if (params.prevPage < params.currentPage) { // Next
                    let url = this.settingStore.getUrl('/fax/history' + this.faxHistory.next_page_url.substring(1));
                    this.getFaxHistory(url);
                }
                else { // Previous
                    let url = this.settingStore.getUrl('/fax/history' + this.faxHistory.prev_page_url.substring(1));
                    this.getFaxHistory(url);
                }
            },
            onPerPageChange(params) {
                this.limit = params.currentPerPage;
                let url = this.settingStore.getUrl('/fax/history');
                this.getFaxHistory(url);
            },
            formatPrice(price)
            {
                return `$${price}`;
            },
            formatPages(count)
            {
                return fix(count);
            },
            formatPhone(number)
            {
                return number;
                // return parsePhoneNumber(number).formatNational()
            },
            formatDate(date)
            {
                return this.moment.unix(date).format('llll');
            }
        }
  }
</script>